export const DATASETS_FETCH = 'DATASETS_FETCH';
export const DATASETS_FETCH_ONE = 'DATASETS_FETCH_ONE';
export const DATASETS_SELECTED_SET = 'DATASETS_SELECTED_SET';
export const DATASETS_SELECTED_CLEAR = 'DATASETS_SELECTED_CLEAR';
export const DATASETS_GENERATE_AS_OF_DATE_COLUMNS = 'DATASETS_GENERATE_AS_OF_DATE_COLUMNS';
export const DATASETS_CHECK_AS_OF_DATE_COLUMN_MODIFICATIONS = 'DATASETS_CHECK_AS_OF_DATE_COLUMN_MODIFICATIONS';
export const DATASETS_HISTORICAL_COLUMN_UPDATED = 'DATASETS_HISTORICAL_COLUMN_UPDATED';

export const DATASETS_REQUERY_COLUMN_LIST = 'DATASETS_REQUERY_COLUMN_LIST';
